import React from 'react';
import TitleRow from '../components/TitleRow';
import TextContainer from '../components/TextContainer';

function Programming() {
  return (
    <div>
      <TitleRow title="Programming"/>
      <TextContainer center="true">
        <p>I also do computer programming. Here is where you can see some of what I've worked on.</p>
      </TextContainer>
    </div>
  );
}

export default Programming;
